<template>
  <div class="container">
    <div id="page1-div" class="container interline border page-container">
      <div class="col-12 p-4">
        <div class="col-12 text-center pt-5 pb-4">
          <u class="ft12Black">
            FORMATO DE CARACTERÍSTICAS DEL BIEN
          </u>
        </div>
        <div class="col-12 text-right">
          <span class="ft11">CD,
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.municipio_cliente }}</span> , <span v-bind:class="{ marca: data.showMarca }">
              {{ data.estado_cliente }}</span> a <span v-bind:class="{ marca: data.showMarca }">
              {{ data.fecha_contrato }}.</span>
          </span>
        </div>
        <div class="col-12 text-justify pt-4">
          <span class="ft10">
            Apoderado o Representante Legal de<br />
            GPI AUTO COMERCIAL SAPI DE C.V.
            <br />
            Por medio de la presente hacemos referencia al contrato de apertura
            de crédito simple con garantía prendaria sin transmisión de la
            posesión, celebrado el día <span v-bind:class="{ marca: data.showMarca }">
              {{ data.fecha_contrato }}</span> (en adelante, el
            "<u class="ft10">Contrato</u>"), entre el suscrito y su
            representada, por lo que: El Acreditado en este acto recibe a su
            entera satisfacción el Bien, de conformidad con las siguientes
            características:
            <br />
            <br />
            Descripción de Vehículo:<br />
            Marca: <span v-bind:class="{ marca: data.showMarca }">
              {{ data.marca_vehiculo }}</span><br />
            Año: <span v-bind:class="{ marca: data.showMarca }">
              {{ data.año_vehiculo }}</span><br />
            Modelo: <span v-bind:class="{ marca: data.showMarca }">
              {{ data.modelo_vehiculo }}</span><br />
            Número de Motor: <span v-bind:class="{ marca: data.showMarca }">
              {{ data.numero_motor_vehiculo }}</span><br />
            Número de Serie: <span v-bind:class="{ marca: data.showMarca }">
              {{ data.numero_serie_vehiculo }}</span><br />

            Información adicional:
            <br />
            Así mismo, el Acreditado acuerda que en su carácter de comprador del
            Bien, está enterado y de acuerdo, que en el caso de cualquier
            consulta y/o reclamación relacionada con el Bien, deberá acudir
            directamente con
            <span class="ft10Black"  v-bind:class="{ marca: data.showMarca }">
              {{ data.pago_tercero }}
            </span>
            en su carácter de
            Proveedor. Por lo tanto, no podrá realizar reclamación ni exigir
            pago alguno que se derive de alguna falla, imperfección, defecto y/o
            vicios ocultos o alguna otra cuestión respecto del Bien,
            reconociendo que
            <u class="ft10">GPI AUTO COMERCIAL SAPI DE C.V.</u>, únicamente
            otorgó el Crédito para la adquisición del Bien, a solicitud del
            Acreditado, por así convenir a sus intereses; por lo que el
            Acreditado deslinda y deberá sacar en paz y a salvo a GPI AUTO
            COMERCIAL SAPI DE C.V. y a cualquier Acreedor y/o tenedor
            subsecuente, de cualquier responsabilidad legal ya sea, penal, civil
            y/o mercantil que pudiera derivarse del Bien.
            <br />
            Cabe señalar que los términos que se encuentren definidos en
            cualquier parte del Contrato, serán aplicables a la presente en lo
            conducente.
            <br />
            Con independencia de lo anterior, el Acreditado acuerda dar
            cumplimiento a las obligaciones derivadas del Contrato.
          </span>
        </div>
        <div class="col-12 row p-5">
          <div class="col-4 text-center"></div>
          <div class="col-4 border-dark text-center">
            <span class="ft11">
              ATENTAMENTE
            </span>
          </div>
          <div class="col-4 text-center"></div>
        </div>

        <div v-if="data.tipoClasico" class="col-12 row">
          <div class="col-3 text-center"></div>
          <div class="col-6 border-bottom border-dark text-center">
            <span v-bind:class="{ marca: data.showMarca }" class="ft11 ">
              {{ data.nombre_cliente }}
            </span>
          </div>
          <div class="col-3 text-center"></div>
        </div>
        <div v-if="data.tipoClasico" class="col-12 row ">
          <div class="col-3 text-center"></div>
          <div class="col-6 text-center pb-5">
            <span class="ft11">
              NOMBRE Y FIRMA DEL ACREDITADO
            </span>
          </div>
          <div class="col-3 text-center"></div>
        </div>
        <div v-if="data.tipoAval" class="col-12 row pt-4">
          <div class="col-4 offset-1 border-top border-dark text-center">
            <span class="ft11">
              <span v-bind:class="{ marca: data.showMarca }" class="ft10Black">
                {{ data.nombre_cliente }}</span><br />
              NOMBRE Y FIRMA DEL ACREDITADO
            </span>
          </div>
          <div class="col-3 text-center">
            <span class="ft11">

            </span>
          </div>
          <div class="col-4 border-top border-dark text-center">
            <span class="ft11">
              <span v-bind:class="{ 'marca-aval': data.showMarca }" class="ft10Black">
                {{ data.nombre_aval }}</span><br />
              NOMBRE Y FIRMA DEL AVAL Y OBLIGADO SOLIDARIO

            </span>
          </div>
        </div>
        <div v-if="data.tipoObligado" class="col-12 row pt-4">
          <div class="col-4 offset-1 border-top border-dark text-center">
            <span class="ft11">
              <span v-bind:class="{ marca: data.showMarca }" class="ft10Black">
                {{ data.nombre_cliente }}</span><br />
              NOMBRE Y FIRMA DEL ACREDITADO
            </span>
          </div>
          <div class="col-3 text-center">
            <span class="ft11">

            </span>
          </div>
          <div class="col-4 border-top border-dark text-center">
            <span class="ft11">
              <span v-bind:class="{ 'marca-obligado': data.showMarca }" class="ft10Black">
                {{ data.nombre_obligado }}</span><br />
              NOMBRE Y FIRMA DEL AVAL Y OBLIGADO SOLIDARIO

            </span>
          </div>
        </div>
        <div v-if="data.tipoObligadoAval" class="col-12 row pt-4">
          <div class="col-3 offset-1 border-top border-dark text-center">
            <span class="ft9">
              <span v-bind:class="{ marca: data.showMarca }" class="ft9Black">
                {{ data.nombre_cliente }}</span><br />
              NOMBRE Y FIRMA DEL ACREDITADO
            </span>
          </div>
          <div class="col-3 offset-1 border-top border-dark text-center">
            <span class="ft9">
              <span v-bind:class="{ 'marca-aval': data.showMarca }" class="ft9Black">
                {{ data.nombre_aval }}</span><br />
              NOMBRE Y FIRMA DEL AVAL Y OBLIGADO SOLIDARIO

            </span>
          </div>
          <div class="col-3 offset-1 border-top border-dark text-center">
            <span class="ft9">
              <span v-bind:class="{ 'marca-obligado': data.showMarca }" class="ft9Black">
                {{ data.nombre_obligado }}</span><br />
              NOMBRE Y FIRMA DEL“AVAL Y OBLIGADO SOLIDARIO"

            </span>
          </div>
        </div>
        <div class="col-12 row pt-5">
          <div class="col-3 text-center pt-5"></div>
          <div class="col-6 border-bottom border-dark text-center"></div>
          <div class="col-3 text-center"></div>
        </div>

        <div class="col-12 row ">
          <div class="col-3 text-center"></div>
          <div class="col-6 text-center">
            <span class="ft11">
              PROVEEDOR
            </span>
          </div>
          <div class="col-3 text-center"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "IntruccionPAgoTErceros",
  data() {
    return {};
  },
  validations() {
    return {};
  },
  props: {
    data: {
      type: Object
    }
  },
  methods: {},
  created() {
    window.scrollTo(0, 0);
  }
};
</script>
<style type="text/scss">
@import "../style.scss";
</style>



// WEBPACK FOOTER //
// src/views/Contratos/cartas/CaracteristicasDelBien.vue